import React, { createContext, useContext, useState } from 'react';

export const ConversationsContext = createContext({});

export const useConversationsContext = () => {
  const context = useContext(ConversationsContext);
  if (!context) {
    throw new Error('useConversations should be used inside ConversationsProvider');
  }
  return context;
};

export const ConversationsProvider = ({ children, selectedConversationId }) => {
  const [conversationsData, setConversationsData] = useState({
    selectedConversationId: selectedConversationId || null,
    conversationInfo: null,
  });

  const updateConversationsData = (newData) => {
    setConversationsData(prevData => ({
      ...prevData,
      ...newData
    }));
  }

  const value = {
    conversationsData,
    updateConversationsData,
  }

  return (
    <ConversationsContext.Provider value={value}>
      {children}
    </ConversationsContext.Provider>
  );
}
